// brackets for bindings parser
var parserBrackets = {
  left: '{{',
  right: '}}'
};
export default parserBrackets;